import { useState } from 'react';
import OverviewHeader from '../components/overview/overview-header';
import QuestionCard from '../components/overview/question-card';
import { useParams } from 'react-router-dom';
import { useViewSurveyData } from '../services/useViewSurveyData';
import OverviewSidePanel from '../components/overview/overview-sidepanel';


const OverviewTab = () => {
  const { extSurveyId } = useParams<{ extSurveyId?: string }>();
  const [activeSection, setActiveSection] = useState<string>('summary');
  const { isShare, surveyId, stats, survey, summary, showSummaries } = useViewSurveyData();

  // Navigation items for the right sidebar
  const navigationItems = [
    { id: 'summary', label: 'Summary', icon: '📊' },
    { id: 'responses', label: 'Responses', icon: '💬' },
    { id: 'demographics', label: 'Demographics', icon: '👥' },
    { id: 'insights', label: 'Insights', icon: '💡' },
  ];

  // Summary data (placeholder - replace with actual data)
  const summaryData = {
    totalResponses: 1250,
    completionRate: '87%',
    avgTime: '4m 32s',
    lastUpdated: '2 hours ago',
  };


  return (
    <div className="flex flex-col h-full bg-gray-50 min-h-0">
      {/* Top Navbar */}
      <OverviewHeader survey={survey} />

      {/* Main Content Area */}
      <div className="flex flex-1 overflow-hidden">

        {/* Main Content Section (2/3 width or more) */}
        <div className="flex-1 overflow-y-auto">
          {stats?.questions.map((question, index) => (
            <QuestionCard
              index={index}
              key={question.id}
              question={question}
            />
          ))}
        </div>

        {/* Right Sidebar (Navigation & Summary) */}
        {stats && (
          <OverviewSidePanel stats={stats} />
        )}

      </div>
    </div>
  );
};

export default OverviewTab;
